export default function IconMore() {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="temp-member-product-scene-btn-icon">
            <g clipPath="url(#clip0_2670_51687)">
                <path d="M12.5 7.19873L8.5 11.1987L4.5 7.19873" stroke="#3F68E0" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2670_51687">
                    <rect width="16" height="16" fill="white" transform="translate(0.5 0.532227)" />
                </clipPath>
            </defs>
        </svg>
    );
}
